module.exports = __webpack_public_path__ + "static/media/geo.4065b8e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/geo.jpg
// module id = 1529
// module chunks = 0